import { render } from "./BvFooter.vue?vue&type=template&id=0557696d&scoped=true"
const script = {}

import "./BvFooter.vue?vue&type=style&index=0&id=0557696d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0557696d"]])

export default __exports__